import React, { useState } from "react";
import styled from "styled-components";
import { Box, CssBaseline, Drawer, Typography } from "@material-ui/core";

import Header from "components/Header";
import Sidebar from "components/Sidebar";
import Footer from "components/Footer";
import Tooltip from "rc-tooltip";

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};
`;

const LinePopup = styled.div`
  position: fixed;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
`;

const Main: React.FC = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Root>
      <CssBaseline />
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
        <Sidebar />
      </Drawer>
      <AppContent>
        <Header onDrawerToggle={handleDrawerToggle} />
        <MainContent>{children}</MainContent>
        <Footer />
        <LinePopup
          onClick={() => {
            window.open("https://lin.ee/fctnyNX", "_blank");
          }}
        >
          <Tooltip
            trigger="hover"
            placement="bottomRight"
            overlayStyle={{ zIndex: "1201" }}
            overlay={
              <Box display={"flex"} flexDirection={"column"} padding={1}>
                <Typography>お問い合わせはLINEから</Typography>
              </Box>
            }
          >
            <img src="/line.png" width="50" height="50" alt={"line popup"} />
          </Tooltip>
        </LinePopup>
      </AppContent>
      {/* 🔴 2026-09-04 …チュートリアルの 呼びを 外しました。
        * 代表 逐語（#タステック-sys 16:19）「そもそもチュートリアルはいまは不要」
        * 　　　　　　　　　　同 16:20「データ数の多い店舗がなんども呼び出しクリックすると結構やばいよね」
        *
        * 実測 …GET /v1/api/staff/tutorial/progress が本番で 404。1 日およそ 10,500 件。
        *   本番の server に この API が出ておらず（dist に tutorial 無し）、
        *   呼ぶたび NestJS が NotFoundException を作って log にも書いていた。
        *   記憶不足で落ちた 3 回（8/27・8/29・9/4）とも 直前がこの 404 だった。
        *
        * 経緯 …2026-07-22 に同じ事故で mount を止め、7/28 に「404 を機能無しと扱う」形で
        *   戻した（1f7fdde5）。ウェルカムは出なくなったが 呼び自体は残っていた。
        *   ⇒ 今回は 呼びが 1 度も起きないよう ここで 外す。
        *
        * ⚠️ 消していない …features/tutorial 一式と server 側の実装は そのまま残す。
        *   server を出す日が来たら この 1 行を戻せば 効く。
        */}
    </Root>
  );
};

export default Main;
